import { ref } from 'vue'
import { defineStore } from 'pinia'
export const useStatusStore = defineStore('status', () => {
  const status = ref('waiting')

  return { status }
})
